export const LOAD_LEVELS = 'LOAD_LEVELS'
export const NEXT_LEVEL = 'NEXT_LEVEL'
export const DECREASE_MOOD = 'DECREASE_MOOD'

export const PREPING_PENDING = 'PREPING_PENDING'
export const PREPING_SUCCESS = 'PREPING_SUCCESS'

export const GAME_COMPLETED = 'GAME_COMPLETED'
export const GAME_OVER = 'GAME_OVER'
export const RESET_GAME = 'RESET_GAME'



// WEBPACK FOOTER //
// ./src/containers/Game/containers/Shop/actionTypes.js